import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c107e00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toast-title" }
const _hoisted_2 = { class: "toast-content" }
const _hoisted_3 = ["href"]

import { storeToRefs } from "pinia";
import useMazeStore from "@/store/mazeStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'MsgMaze',
  setup(__props) {

const store = useMazeStore();
const info = storeToRefs(store);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h5", _hoisted_1, _toDisplayString(_unref(info).toast_info.value.title), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(info).toast_info.value.message), 1),
    (_unref(info).toast_info.value.link)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "toast-link",
          href: _unref(info).toast_info.value.link,
          target: '_blank'
        }, "Open transaction in explorer:", 8, _hoisted_3))
      : _createCommentVNode("", true)
  ], 64))
}
}

})